module.exports = __webpack_public_path__ + "static/media/toilet_paper_getty_desktop.0a068e48.jpg";